var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntreFechas({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_6077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 12.3333V31H11V12.3333H14.9375V11H16.25V12.3333H26.75V11H28.0625V12.3333H32ZM12.3125 13.6667V16.3333H30.6875V13.6667H28.0625V15H26.75V13.6667H16.25V15H14.9375V13.6667H12.3125ZM30.6875 29.6667V17.6667H12.3125V29.6667H30.6875Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2108 24.8164V26.4831C21.2108 26.6772 21.2108 26.7743 21.287 26.8509C21.3885 26.9529 21.5831 27.0341 21.8281 27.0764C22.0119 27.1081 22.2449 27.1081 22.7108 27.1081C23.1768 27.1081 23.4097 27.1081 23.5935 27.0764C23.8385 27.0341 24.0332 26.9529 24.1347 26.8509C24.2108 26.7743 24.2108 26.6772 24.2108 26.4831V24.8164C24.2108 24.6223 24.2108 24.5252 24.1347 24.4486C24.0332 24.3465 23.8385 24.2654 23.5935 24.2231C23.4097 24.1914 23.1768 24.1914 22.7108 24.1914C22.2449 24.1914 22.0119 24.1914 21.8281 24.2231C21.5831 24.2654 21.3885 24.3465 21.287 24.4486C21.2108 24.5252 21.2108 24.6223 21.2108 24.8164Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8945 24.8164V26.4831C14.8945 26.6772 14.8945 26.7743 14.9707 26.8509C15.0721 26.9529 15.2668 27.0341 15.5118 27.0764C15.6956 27.1081 15.9286 27.1081 16.3945 27.1081C16.8605 27.1081 17.0934 27.1081 17.2772 27.0764C17.5222 27.0341 17.7169 26.9529 17.8184 26.8509C17.8945 26.7743 17.8945 26.6772 17.8945 26.4831V24.8164C17.8945 24.6223 17.8945 24.5252 17.8184 24.4486C17.7169 24.3465 17.5222 24.2654 17.2772 24.2231C17.0934 24.1914 16.8605 24.1914 16.3945 24.1914C15.9286 24.1914 15.6956 24.1914 15.5118 24.2231C15.2668 24.2654 15.0721 24.3465 14.9707 24.4486C14.8945 24.5252 14.8945 24.6223 14.8945 24.8164Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_6077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntreFechas);
export default __webpack_public_path__ + "static/media/EntreFechas.623fa77f6e3aa36bcd745f6ebd1c4e28.svg";
export { ForwardRef as ReactComponent };